import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import { v4 as uuidv4 } from "uuid";
import { logError } from "../../redux/actions";
import { SILENT_ERROR } from "./ErrorConstants";

const GlobalErrorHandler = ({ children }) => {
    const dispatch = useDispatch();
    const selectedSessionID = useSelector((state) => _.get(state, ["playlist", "data", "routeID"], null));

    const onUnhandledError = (e) => {
        const uuid = uuidv4();
        const sessionID = String(selectedSessionID).trim();

        // Include selected session ID in global error metadata
        const sessionIdForLog = sessionID !== "" ? sessionID : "No session selected";

        const errorMetadata = {
            message: e,
            stack: null,
            componentStack: null,
            url: window.location.href,
            selectedSessionID: sessionIdForLog,
            errorType: SILENT_ERROR,
            uuid,
            frontendVersion: process.env["REACT_APP_GIT_VERSION"],
        };

        if (window.location.hostname !== "localhost" && window.location.hostname !== "127.0.0.1") {
            dispatch(logError(errorMetadata));
        }
    };

    useEffect(() => {
        window.onerror = onUnhandledError;
    });
    return <>{children}</>;
};

export default GlobalErrorHandler;
